var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: 'foldable', base: 'fields', prototype: {
    element_selector: '.foldable',
    duration: 200,

    init: function (params) {
      // TODO: Надо будет на этой базе и аккордеон сделать.
      xP.controls.foldable.base.init.apply(this, arguments);

      if (this.$label && this.$label[0]) {
        this.fold(
          !(
          this.unfolded
          || this.$label.hasClass(this.unfolded_class)
          ),
          1
        );

        var that = this;

        this.$label.click(function () {
          that.fold(that.unfolded);
        });
      }
    },

    fold: function (fold, _duration) {
      this.unfolded = !fold;

      if (fold) {
        this.$container.add(this.$label)
          .removeClass(this.unfolded_class)
          .addClass(this.folded_class);

        this.$container.slideUp(_duration || this.duration);
      } else {
        this.$container.add(this.$label)
          .removeClass(this.folded_class)
          .addClass(this.unfolded_class);

        this.$container.slideDown(_duration || this.duration);
      }

      return this;
    },

    folded_class: 'folded',
    unfolded_class: 'unfolded'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/foldable.js
 ** module id = 18
 ** module chunks = 0
 **/